class MenuSettingsController {
  /* @ngInject */
  constructor($log, $filter, MerchantConfigurationService, CatalogService, FoundationApi /* ,StorageService*/) {
    const that = this;

    that.loading = {
      settings: false
    };

    that.settings = {
      menu: {
        enabled: false
      },
      orderAndPick: {
        enabled: false
      },
      orderAndTable: {
        enabled: false
      }
    };

    that.hasMenu = false;

    that.isSuperAdmin = false;

    that.settingsDialog = {
      id: 'setting_dialog',
      title: 'Informazione',
      text: $filter('translate')('menu.settings.modal'),
      isConfirm: false,
      closeFunc: undefined,
      confirmFunc: {}
    };

    const loadSettings = () => {
      CatalogService.getMenus().then((menu) => {
        if (menu.length > 0) {
          that.hasMenu = true;
          // that.isSuperAdmin = StorageService.getLocalStorage('superAdmin');
        }
      });

      if (that.loading.settings) return;
      that.loading.settings = true;
      MerchantConfigurationService.getCheckinConfiguration().then((settings) => {
        that.settings = settings;
      }, (reason) => {
        $log.error('CheckinSettingsController', 'loadSettings', reason);
      }).finally(() => {
        that.loading.settings = false;
      });
    };

    const init = () => {
      loadSettings();
    };

    that.$onInit = init;

    that.save = () => {
      if (that.loading.settings) return;
      that.loading.settings = true;
      if (that.hasMenu === true) {
        MerchantConfigurationService.setOrderAndPayConfiguration(that.settings).then(loadSettings, (reason) => {
          $log.error('CheckinSettingsController', 'save', reason);
        }).finally(() => {
          that.loading.settings = false;
        });
      } else {
        that.loading.settings = false;
        if (that.settings.menu.enabled === true) {
          that.settings.menu.enabled = !that.settings.menu.enabled;
          setTimeout(() => { FoundationApi.publish('setting_dialog', 'open'); }, 300);
        }
      }
    };

    that.reset = loadSettings;
  }
}

export default MenuSettingsController;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/settings/settings.controller.js
 **/